import { CardHeader } from "@mui/material";
import { JSX } from "react";
import ActionMenu from "../../../components/action-menu/ActionMenu";
import { ActionMenuItem } from "../../../components/action-menu/ActionMenuItem";
import { IUICustomizationPresetDescriptionDTO } from "../../../services/ui-customization-data-service/Models";
import PresetAvatar from "./UICustomizationPresetAvatar";
import UICustomizationPresetSubheader from "./UICustomizationPresetSubheader";
import UICustomizationPresetTitle from "./UICustomizationPresetTitle";

export type UICustomizationPresetCardHeaderProps = {
    preset: IUICustomizationPresetDescriptionDTO;
    actionItems: ActionMenuItem[];
};

export default function UICustomizationPresetCardHeader({
    preset,
    actionItems
}: UICustomizationPresetCardHeaderProps): JSX.Element {
    return (
        <CardHeader
            sx={{
                padding: 1
            }}
            title={<UICustomizationPresetTitle preset={preset} />}
            avatar={<PresetAvatar />}
            subheader={<UICustomizationPresetSubheader preset={preset} />}
            action={
                <ActionMenu
                    actionItems={actionItems}
                    hideIfEmpty={true}
                />
            } />
    );
}
